export default "/assets/images/hero_mila2.png?e0123c4549e5250ad1caf3969e6c1526";